import {
  LdModal,
  LdProgress,
  LdTypo,
} from "@emdgroup-liquid/liquid/dist/react";

import { ShowProgressProps } from "@src/types";

const ShowProgress = ({
  loading,
  headerText,
  message,
  footerMessage,
  cancelable,
}: ShowProgressProps) => {
  return (
    <LdModal open={loading} cancelable={cancelable}>
      <LdTypo slot="header" variant="h4">
        {headerText}
      </LdTypo>
      <LdTypo
        style={{ textAlign: "center", marginBottom: "10px" }}
        variant="h5"
      >
        {message}
      </LdTypo>
      <LdProgress pending aria-valuetext="indeterminate" />
      <LdTypo style={{ textAlign: "center" }}>{footerMessage}</LdTypo>
    </LdModal>
  );
};

export { ShowProgress };
